// extracted by mini-css-extract-plugin
export default {"about":"About_about__dW94r","hero":"About_hero__GtkpW","heroImage":"About_heroImage__ZfACO","sections":"About_sections__h+gQf","aboutText":"About_aboutText__JMl9b"};